export default {
    topics: [
        {
            title: ' FilePublishing ',
            href: 'sm-fileRes-FilePublishing.html',
            attributes: { 'data-id': 'sm-fileRes-FilePublishing' },
            menu: { hasChildren: false },
            tocID: 'sm-fileRes-FilePublishing-d66e521',
            topics: [],
        },
        {
            title: ' GetPublicFileResURL ',
            href: 'sm-fileRes-GetPublicFileResURL.html',
            attributes: { 'data-id': 'sm-fileRes-GetPublicFileResURL' },
            menu: { hasChildren: false },
            tocID: 'sm-fileRes-GetPublicFileResURL-d66e529',
            topics: [],
        },
        {
            title: ' GetServerFileName ',
            href: 'sm-fileRes-GetServerFileName.html',
            attributes: { 'data-id': 'sm-fileRes-GetServerFileName' },
            menu: { hasChildren: false },
            tocID: 'sm-fileRes-GetServerFileName-d66e537',
            topics: [],
        },
        {
            title: ' GetURL ',
            href: 'sm-fileRes-GetURL.html',
            attributes: { 'data-id': 'sm-fileRes-GetURL' },
            menu: { hasChildren: false },
            tocID: 'sm-fileRes-GetURL-d66e545',
            topics: [],
        },
        {
            title: ' PostUpload ',
            href: 'sm-fileRes-PostUpload.html',
            attributes: { 'data-id': 'sm-fileRes-PostUpload' },
            menu: { hasChildren: false },
            tocID: 'sm-fileRes-PostUpload-d66e553',
            topics: [],
        },
        {
            title: ' PreDownload ',
            href: 'sm-fileRes-PreDownload.html',
            attributes: { 'data-id': 'sm-fileRes-PreDownload' },
            menu: { hasChildren: false },
            tocID: 'sm-fileRes-PreDownload-d66e561',
            topics: [],
        },
        {
            title: ' PublishIfNeeded ',
            href: 'sm-fileRes-PublishIfNeeded.html',
            attributes: { 'data-id': 'sm-fileRes-PublishIfNeeded' },
            menu: { hasChildren: false },
            tocID: 'sm-fileRes-PublishIfNeeded-d66e569',
            topics: [],
        },
        {
            title: ' PublishIfNeededFromId ',
            href: 'sm-fileRes-PublishIfNeededFromId.html',
            attributes: { 'data-id': 'sm-fileRes-PublishIfNeededFromId' },
            menu: { hasChildren: false },
            tocID: 'sm-fileRes-PublishIfNeededFromId-d66e577',
            topics: [],
        },
        {
            title: ' WebPostUpload ',
            href: 'sm-fileRes-WebPostUpload.html',
            attributes: { 'data-id': 'sm-fileRes-WebPostUpload' },
            menu: { hasChildren: false },
            tocID: 'sm-fileRes-WebPostUpload-d66e585',
            topics: [],
        },
    ],
};

